import type { MessageDescriptor } from 'react-intl';

import { planPriceDisplayMessages } from './plan-price-display-messages';

const GST_REGIONS = new Set(['AU', 'NZ']);

/** Pick GST vs generic tax caption from locale region. */
export function resolvePlanPriceDisplayTaxCaption(locale: string): MessageDescriptor {
  try {
    const region = new Intl.Locale(locale).maximize().region;
    if (region && GST_REGIONS.has(region)) {
      return planPriceDisplayMessages.excludeGst;
    }
  } catch {
    // invalid locale → generic caption
  }

  return planPriceDisplayMessages.excludeTax;
}
